module.exports = __webpack_public_path__ + "20d62fc183d0adcc501525331b800515.svg";